exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-6308e03c]{padding-left:10px;padding-right:10px}.item .list[data-v-6308e03c]:last-child{margin-bottom:0}.line2[data-v-6308e03c]{height:42px;line-height:22px;margin-bottom:18px}.empty-box[data-v-6308e03c]{width:100%;height:78px;background:#f3f9ff}.list .item[data-v-6308e03c]:last-child{margin-bottom:0 !important}.list .item .pictrues[data-v-6308e03c]{width:125px;height:78px}.list .item .pictrues .pic[data-v-6308e03c]{width:100%;height:100%;border-radius:7px}.list .item .text[data-v-6308e03c]{height:78px;font-size:15px;color:#333}.text-box[data-v-6308e03c]{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-left:10px}", ""]);

// exports
